import createEnum from 'lib/createEnum';

export const serverErrors = createEnum('IDENTITY_TOKEN_TIMEOUT', 'IDENTITY_TOKEN_ERROR');
export const chatClientConnectionStatuses = createEnum('CONNECTED', 'RECONNECTING', 'DISCONNECTED');

export default {
  serverErrors,
  chatClientConnectionStatuses,
};
